module.exports = __webpack_public_path__ + "img/857B61_ACE5D4_593D28_5B4334-256px.d04b868d.png";